export default "__VITE_ASSET__DTM3Wyho__"